import type { MatchDetailed, UpdateMatchRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateMatchDetails(matchId: string, formData: UpdateMatchRequest): Promise<MatchDetailed> {
  return requestApiJsonOrThrow<MatchDetailed>(`admin/matches/${matchId}`, {
    method: 'PATCH',
    body: formData,
  })
}
